var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveFriendIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.082 2a4.494 4.494 0 1 0 0 8.989 4.494 4.494 0 0 0 0-8.989zM10.534 13.177c.252-.366.012-.922-.433-.921h-.41l-.795.001a6.688 6.688 0 0 0-6.688 6.688 2.73 2.73 0 0 0 2.73 2.73h5.221c.45 0 .693-.574.432-.941a6.555 6.555 0 0 1-1.22-3.82c0-1.388.43-2.675 1.163-3.737z",
    fill: "#fff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.041 16.915a5.085 5.085 0 1 1-10.17 0 5.085 5.085 0 0 1 10.17 0zm-2.726-2.36a.75.75 0 0 1 0 1.062l-.945.944a.5.5 0 0 0 0 .708l.945.945a.75.75 0 0 1-1.06 1.06l-.945-.945a.5.5 0 0 0-.707 0l-.945.945a.75.75 0 0 1-1.06-1.06l.944-.945a.5.5 0 0 0 0-.707l-.945-.945a.75.75 0 0 1 1.06-1.061l.946.945a.5.5 0 0 0 .707 0l.945-.945a.75.75 0 0 1 1.06 0z",
    clipRule: "evenodd",
    fill: "#fff",
    opacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFriendIconDark);
export default __webpack_public_path__ + "static/media/remove_friend_icon_dark.96b8f72c201936da5578c2e700d63a2b.svg";
export { ForwardRef as ReactComponent };